export class Event {
    target;
    type;
    constructor(type, target) {
        this.target = target;
        this.type = type;
    }
}
export class ErrorEvent extends Event {
    message;
    error;
    constructor(error, target) {
        super('error', target);
        this.message = error.message;
        this.error = error;
    }
}
export class CloseEvent extends Event {
    code;
    reason;
    wasClean = true;
    constructor(code = 1000, reason = '', target) {
        super('close', target);
        this.code = code;
        this.reason = reason;
    }
}
//# sourceMappingURL=events.js.map